import { fetchWithAdmin } from './fetchHelper';

/** One campaign value, merged from every record that holds one — backend
 *  `admin/analytics/campaigns.ts`. */
export interface CampaignRow {
  campaign: string;
  /** Typed in by someone, for a value that is an id. */
  name?: string;
  kind: 'meta-ad' | 'link-label' | 'tagged-url';
  /** New accounts in the window whose first touch carried it. */
  newPeople: number;
  signedUp: number;
  /** Of the new people, whose landing URL carried an ad click id. */
  withClickId: number;
  sources: string[];
  /** Follows of our published links that carried it. */
  linkFollows: number;
  /** Meta clicks recorded — only arrivals with an `fbclid`. */
  metaClicks: number;
  /** Published links labelled with it. */
  links: string[];
  lastSeenAt?: string;
}

const range = (from: Date, to: Date) =>
  `from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`;

export const campaignsApi = {
  list: (from: Date, to: Date) =>
    fetchWithAdmin<{ from: string; to: string; campaigns: CampaignRow[] }>(`/console/campaigns?${range(from, to)}`),
  /** Every named campaign value — what the other tables show a name for. */
  names: () => fetchWithAdmin<{ names: Record<string, string> }>('/console/campaigns/names'),
  /** Name a campaign value; an empty name removes it. */
  setName: (campaign: string, name: string) =>
    fetchWithAdmin<{ campaign: string; name?: string }>('/console/campaigns/names', {
      method: 'PUT', body: JSON.stringify({ campaign, name }),
    }),
};

/** A value that looks like a platform id rather than something a person typed. */
export const looksLikeId = (v: string) => /^\d{8,}$/.test(v);
